import { badgeFor } from "../lib/badges";

export function Badge({ user, size = "md" }) {
  const cfg = badgeFor(user);
  if (!cfg) return null;
  const dims = size === "sm" ? { pad: "pl-1.5 pr-3 py-1", ic: "w-5 h-5", is: 12, tx: "text-[10px]" } : { pad: "pl-2 pr-4 py-1.5", ic: "w-7 h-7", is: 14, tx: "text-[11px]" };
  const Icon = cfg.Icon;
  return (
    <span
      data-testid="account-badge"
      className={`inline-flex items-center gap-2 rounded-full border ${dims.pad}`}
      style={{ borderColor: `${cfg.glow}55`, background: `linear-gradient(135deg, ${cfg.from}22, ${cfg.to}0D)`, boxShadow: `0 0 22px ${cfg.glow}22` }}
    >
      <span className={`grid place-items-center ${dims.ic} rounded-full text-black`} style={{ background: `linear-gradient(135deg, ${cfg.from}, ${cfg.to})` }}>
        <Icon size={dims.is} strokeWidth={2.2} />
      </span>
      <span className={`font-grotesk ${dims.tx} uppercase tracking-[0.18em] font-semibold`} style={{ color: cfg.to }}>
        {cfg.label}
      </span>
    </span>
  );
}
